<template>
  <v-container>
    <base-card>
      <v-img :src="banner.src" :lazy-src="banner.src" width="100%">
        <template v-slot:placeholder>
          <BaseImageLoading />
        </template>
      </v-img>
    </base-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Banner",
  computed: {
    ...mapState("pictures", ["banner"]),
  },
};
</script>
